import { FC } from 'react';
import { SvgIconProps } from '@mui/material';
import colors from '@styles/colors.module.scss';
import { Icon } from '@components/Icon';

export const LeftArrowIcon: FC<SvgIconProps> = (props) => {
  return <Icon {...props} name="chevronLeft" htmlColor={colors.black} />;
};
